import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { FOUNDER_IMAGE, CONTACT } from "../../data/content";

export default function FounderSection() {
  return (
    <section data-testid="founder-section" className="ground-ink text-[color:var(--paper)] sec-pad">
      <div className="wrap grid lg:grid-cols-12 gap-x-10 gap-y-12 items-start">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-5"
        >
          <div className="frame aspect-[4/5] w-full max-w-[480px]">
            <img
              src={FOUNDER_IMAGE}
              alt="Jasmeen Kaur"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <p className="stamp mt-4" style={{ color: "var(--paper)", fontSize: 11 }}>
            Jasmeen Kaur · Researcher, Translator, Trainer
          </p>
        </motion.div>

        <div className="lg:col-span-7 lg:pl-8">
          <p className="stamp on-ink mb-4" style={{ color: "var(--paper)", fontSize: 12 }}>About</p>

          <h2 className="h-section" style={{ fontSize: "clamp(28px, 3.6vw, 48px)", lineHeight: 1.08 }}>
            A decade inside <span className="claim">real learning rooms.</span>
          </h2>

          <div className="mt-8 font-body-serif measure text-[color:rgba(239,231,214,0.9)]" style={{ fontSize: 18, lineHeight: 1.7 }}>
            <p>
              I&rsquo;m Jasmeen Kaur. My work sits at the intersection of research, learning design and live facilitation. Over the past decade, I have worked across enterprises, educational institutions and early-career programmes — studying what helps people move from knowing a framework to using it when the room becomes difficult.
            </p>
            <p className="mt-5" style={{ color: "var(--paper)" }}>
              Articulex is the human capability practice built from that work.
            </p>
          </div>

          <div className="mt-10 flex flex-wrap gap-6">
            <Link to="/about" data-testid="founder-more-link" className="arrow-link on-ink">
              More about Jasmeen <ArrowUpRight size={14} />
            </Link>
            <a href={CONTACT.linkedin} target="_blank" rel="noreferrer" data-testid="founder-linkedin-link" className="arrow-link on-ink">
              LinkedIn <ArrowUpRight size={14} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
